import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Query from './Query'
import Hero, { HeroTitle } from '../Hero'
import Layout from '../Layout'
import TeamMembers from './TeamMembers'
import SearchForm from './SearchForm'
import Filters from './Filters'
import { setHashParam, getHashParam } from '../../helpers/url'
import Navigation from '../AboutPage/Navigation'

const PageContent = ({ content, teamMembers }) => {
  const [activeFilter, setActiveFilter] = useState(getHashParam('team'))
  const [search, setSearch] = useState('')
  const [filteredTeamMembers, setFilteredTeamMembers] = useState(
    getFilteredTeamMembers()
  )

  function getSearchedTeamMembers(teamMembers, search) {
    return teamMembers.filter((member) => {
      if (
        (member.display_name || member.title)
          .toLowerCase()
          .includes(search.toLowerCase())
      )
        return true
      if (
        (member.content.location || '')
          .toLowerCase()
          .includes(search.toLowerCase())
      )
        return true
      if (
        member.content.job_titles
          .map((job) => job.name.toLowerCase())
          .join(' ')
          .includes(search.toLowerCase())
      )
        return true
      return false
    })
  }

  function getFilteredTeamMembers() {
    let members = teamMembers.filter(
      (member) => member.team && member.is_active
    )
    if (activeFilter)
      members = members.filter((member) => member.team === activeFilter)
    if (search) members = getSearchedTeamMembers(members, search)
    return members
  }

  useEffect(() => {
    setFilteredTeamMembers(getFilteredTeamMembers())
  }, [search, activeFilter])

  function updateActiveFilter(filter) {
    setActiveFilter(filter)
    setSearch('')
    setHashParam('team', filter)
  }

  return (
    <Layout>
      <Hero>
        <HeroTitle useH1>{content.title}</HeroTitle>
        <Filters activeFilter={activeFilter} onChange={updateActiveFilter} />
        <SearchForm
          search={search}
          totalResults={filteredTeamMembers.length}
          onSubmit={setSearch}
        />
      </Hero>
      <Navigation />
      <TeamMembers
        teamLabels={content.teams}
        teamMembers={filteredTeamMembers}
        noResults={content.no_results}
      />
    </Layout>
  )
}

PageContent.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    results: PropTypes.string.isRequired,
    no_results: PropTypes.string.isRequired,
    teams: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired
      })
    )
  }),
  teamMembers: PropTypes.arrayOf(
    PropTypes.shape({
      team: PropTypes.string.isRequired,
      is_active: PropTypes.bool.isRequired,
      display_name: PropTypes.string,
      title: PropTypes.string,
      content: PropTypes.shape({
        location: PropTypes.string,
        job_titles: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string.isRequired
          })
        )
      })
    })
  )
}

const TeamPage = ({ fragment }) => (
  <Query
    render={({ content, teamMembers }) => (
      <PageContent
        fragment={fragment}
        content={content}
        teamMembers={teamMembers}
      />
    )}
  />
)

TeamPage.propTypes = {
  fragment: PropTypes.string
}

export default TeamPage
